import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  NavLink,
  HashRouter,
} from "react-router-dom";
import Header from "./../../Header";
import Pagination from "react-js-pagination";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import $ from "jquery";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import "./../../bootstrap/css/daterangepicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class LeaveLops extends Component {
  constructor() {
    super();
    var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(localStorage.getItem("encdata"), 0)
      : "";
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      userAuthKey: has_local_data ? localdata.user_key : "",
      userId: has_local_data ? localdata.user_id : "",
      userEmail: has_local_data ? localdata.user_email : "",
      search: "",
      loading: 1,
      activePage: 1,
      from_date: "",
      to_date: "",
      default_start_date: "",
      default_end_date: "",
      default_date: "",
      minDate: moment().subtract(6, "months").startOf("month").toDate(),
      maxDate: moment().endOf("month").toDate(),
      selectedDate: new Date(),
      selectedMonth: currentMonth,
      selectedYear: currentYear,
      from_date: moment(currentDate).format("YYYY-MM-DD"),
      to_date: moment(currentDate).format("YYYY-MM-DD"),
      pastMonths: this.getPastSixMonths(currentYear, currentMonth),
    };
    this.searchChange = this.searchChange.bind(this);
    this.calculateLeaveLops = this.calculateLeaveLops.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }

  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }

  leavesDateRangeSrch(start_date, end_date) {
    console.log(54, start_date);
    console.log(54, end_date);
    this.setState(
      {
        from_date: start_date.format("YYYY-MM-DD"),
        to_date: end_date.format("YYYY-MM-DD"),
        activePage: 1,
      },
      function () {
        this.calculateLeaveLops();
      }
    );
  }
  async componentWillMount() {
    document.title = "Intranet | Leave Lops";
    if (!localStorage.getItem("userLogin")) {
      this.setState({ redirect: true });
    }
    var date = new Date();
    var start_date = new Date(date.getFullYear(), date.getMonth(), 1);
    var end_date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    var default_date =
      moment(start_date).format("DD/MM/YYYY") +
      "-" +
      moment(end_date).format("DD/MM/YYYY");
    var default_start_date = moment(start_date).format("MM/DD/YYYY");
    var default_end_date = moment(end_date).format("MM/DD/YYYY");
    this.setState(
      {
        from_date: moment(start_date).format("YYYY-MM-DD"),
        to_date: moment(end_date).format("YYYY-MM-DD"),
        default_date,
        default_start_date,
        default_end_date,
      },
      function () {
        this.calculateLeaveLops();
      }
    );
  }

  handlePageChange(pageNumber = 1) {
    var totalPages = Math.ceil(this.state.item_count / 20);
    if (this.state.activePage != pageNumber) {
      $(document).ready(function () {
        $(".pages").addClass("disabled");
      });
      this.setState({ activePage: pageNumber, setPage: "no" });
      fetch(
        this.state.apiUrl +
        "/HrmanagementRest/calculateLeaveLops/page/" +
        pageNumber +
        "/userAuthKey/" +
        this.state.userAuthKey +
        "/userId/" +
        this.state.userId,
        {
          method: "POST",
          dataType: "json",
          body: JSON.stringify(this.state),
        }
      )
        .then((Response) => Response.json())
        .then((findresponse) => {
          console.log({ findresponse });
          findresponse = this.decrypt(findresponse, 1);
          $(document).ready(function () {
            $(".pages").removeClass("disabled");
            if (pageNumber == 1) {
              $(".first_page").addClass("disabled");
              $(".prev_page").addClass("disabled");
            }
            if (pageNumber == totalPages) {
              $(".next_page").addClass("disabled");
              $(".last_page").addClass("disabled");
            }
          });
          this.setState({
            users: findresponse.users,
            offset: findresponse.offset,
            off_count: findresponse.off_count,
            setPage: "yes",
          });
        });
    }
  }

  calculateLeaveLops(page = 1) {
    fetch(
      this.state.apiUrl +
      "/HrmanagementRest/calculateLeaveLops/page/" +
      page +
      "/userAuthKey/" +
      this.state.userAuthKey +
      "/userId/" +
      this.state.userId,
      {
        method: "POST",
        dataType: "json",
        body: JSON.stringify(this.state),
      }
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = this.decrypt(findresponse, 1);
        console.log({ findresponse });
        this.setState({
          users: findresponse.users,
          item_count: findresponse.item_count,
          loading: 0,
          hr_permission: findresponse.hr_permission,
          offset: findresponse.offset,
          off_count: findresponse.off_count,
          setPage: "yes",
        });
      });
  }

  getUserRows() {
    if (this.state.loading) {
      return <div class="loader-new"></div>;
    } else {
      return (
        <div class="body-content">
          <div class="employee-list table-wrap">
            <table>
              <thead>
                <th>Employee Name</th>
                <th>LOP Start Date</th>
                <th>LOP End Date</th>
                <th id="col_available_leaves">Count</th>
              </thead>
              <tbody>
                {this.state.users.map((user, key) => {
                  console.log({ user });
                  return (
                    <tr>
                      <td>
                        <Link
                          key={key}
                          to={`/viewLeaveReward/${user.id}`}
                          name={"max"}
                        >
                          {user.name}
                        </Link>
                      </td>
                      <td>{user.lop_start_date}</td>
                      <td>{user.lop_end_date}</td>
                      <td>{user.lop_cnt}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {this.state.item_count > 0 ? (
              <div
                class="d-flex mu-pagination justify-content-between align-items-center"
                aria-label="Page navigation example"
              >
                <div class="txt-dark">
                  Showing {this.state.offset + 1}~
                  {this.state.offset + this.state.off_count} of{" "}
                  {this.state.item_count}
                </div>
                <div class="mu-pagination">
                  <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={20}
                    totalItemsCount={this.state.item_count}
                    pageRangeDisplayed={5}
                    itemClass="page-item"
                    linkClass="page-link"
                    onChange={
                      this.state.setPage == "yes" ? this.handlePageChange : ""
                    }
                  />
                </div>
              </div>
            ) : (
              <div
                className="text-center"
                style={{
                  color: "#333",
                  fontSize: "16px",
                  padding: "70px",
                  fontWeight: "500",
                }}
              >
                No Data Found
              </div>
            )}
          </div>
        </div>
      );
    }
  }

  searchChange(event) {
    var obj = this;
    this.setState({ search: event.target.value, activePage: 1 });
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(function () {
      obj.calculateLeaveLops();
    }, 500);
  }

  Back() {
    window.history.back();
  }

  handleDateChange = (date) => {
    const selectedMonth = date.getMonth();
    const selectedYear = date.getFullYear();

    const firstDay = new Date(selectedYear, selectedMonth, 1);
    const lastDay = new Date(selectedYear, selectedMonth + 1, 0);

    this.setState(
      {
        selectedDate: date,
        selectedMonth,
        selectedYear,
        from_date: moment(firstDay).format("YYYY-MM-DD"),
        to_date: moment(lastDay).format("YYYY-MM-DD"),
      },
      () => {
        this.calculateLeaveLops();
      }
    );
  };

  getPastSixMonths(currentYear, currentMonth) {
    const months = [];
    let month = currentMonth;
    let year = currentYear;

    for (let i = 0; i < 7; i++) {
      months.unshift({ month, year });
      month--;

      if (month < 0) {
        month = 11;
        year--;
      }
    }

    return months;
  }

  handleMonthChange = (event) => {
    const selectedMonth = parseInt(event.target.value, 10);
    const selectedMonthData = this.state.pastMonths.find(
      (item) => item.month === selectedMonth
    );
    const selectedYear = selectedMonthData ? selectedMonthData.year : null;

    if (!selectedYear) {
      console.error("Invalid month or year selection");
      return;
    }

    const firstDay = new Date(selectedYear, selectedMonth, 1);
    const lastDay = new Date(selectedYear, selectedMonth + 1, 0);

    this.setState(
      {
        selectedMonth,
        selectedYear,
        from_date: moment(firstDay).format("YYYY-MM-DD"),
        to_date: moment(lastDay).format("YYYY-MM-DD"),
      },
      () => {
        this.calculateLeaveLops();
      }
    );
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }
    if (this.state.hr_permission == "no") {
      return <Redirect to={"/home"} />;
    }
    const handleApply = (event, picker) => {
      picker.element.val(
        picker.startDate.format("DD/MM/YYYY") +
        " - " +
        picker.endDate.format("DD/MM/YYYY")
      );
      this.leavesDateRangeSrch(picker.startDate, picker.endDate);
    };
    const handleCancel = (event, picker) => {
      window.location.href = "/leaveLops";
    };
    const handleCallback = (start, end) => {
      this.leavesDateRangeSrch(start, end);
    };

    const { pastMonths, selectedMonth } = this.state;

    // Generate month options based on the pre-calculated past six months
    const monthOptions = pastMonths.map(({ month, year }) => (
      <option value={month} key={`${year}-${month}`}>
        {moment().month(month).format("MMMM")} {year}
      </option>
    ));

    return (
      <div>
        <Header brecum_name="Leave Lops" brecum_page="Leave Lops" />
        <div class="right_col">
          <div class="intranet_body">
            <div class="title mob hidden-sm">
              <span>Leave Lops</span>
            </div>
            <div class="top-row">
              <div class="left-section leavelop btn-muvi pull-left">
                <a onClick={() => this.Back()} class="btn btn-blue mob">
                  Back
                </a>
              </div>
              <div class="right-section leavelop pull-right">
                <div class="col-sm-4 col-xs-4 icon-calender">
                  <div className="filter">
                    {/* Month Dropdown */}
                    <div className="form-group">
                      <select
                        value={selectedMonth}
                        onChange={this.handleMonthChange}
                        className="form-control month-select"
                      >
                        {monthOptions}
                      </select>
                    </div>
                  </div>
                  {/* <i class="fal fa-calendar-alt"></i> */}
                </div>
                <div class="col-md-8 col-xs-12">
                  <div class="searchTicket emp_dept">
                    <input
                      placeholder="Search By Name Or Employee Id"
                      onChange={this.searchChange}
                    />
                    <button type="submit">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                  <div class="searchTicket filter dept hidden-md">
                    <i class="fa fa-sliders hidden-md filter"></i>
                  </div>
                </div>
              </div>
            </div>
            {this.getUserRows()}
          </div>
        </div>
      </div>
    );
  }
}
export default LeaveLops;



// WEBPACK FOOTER //
// ./src/components/hrAdmin/leaveLops.js